<template lang="pug">
div
  template(v-for="field in fields")
    .transition-checklist-field(v-if="field.type === 'checklist'", :key="field.name")
      .form-field-label
        span {{ field.label }}
        span.form-field-require-tag(v-show="field.require", :title="notifies.required_field")
          | *
      .transition-checklist-field__status(v-if="field.checklist_status_title")
      checklist-passing-launcher(
        :checklist="getChecklistData(field)",
        :parentData="checklistParentData",
        @checklist-updated="data => onChecklistUpdated(field, data)"
      )
      .valid-error-message.transition-checklist-field__error(v-if="showChecklistError(field)") {{ checklistRequiredErrorMessage }}
    component(
      v-else,
      :key="field.name",
      :is="getFieldComponent(field.type)",
      @fields-loaded="fieldsLoaded",
      :parentData="{ grid: grid, data: getFieldData(field), allFields: fields }",
      @fieldIsForbidden="fieldIsForbidden"
    )
</template>

<script>
import fields from "../forms/fields";
import checklistPassingLauncher from "../../view/checklists/passing/launcher.vue";
import i18n from "@/plugins/vue-i18n";

import { useEmitter } from "@/services/useEmitter";

const completedChecklistStatuses = ["completed", "completed_with_deviation"];

export default {
  components: {
    fields,
    checklistPassingLauncher,
  },

  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      action: this.parentData.action,
      row: this.parentData.row,
      fields: this.parentData.data,
      grid: this.parentData.grid,

      loading_fields: [],
      loading: true,
      emitter: useEmitter(),
    };
  },

  computed: {
    checklistRequiredErrorMessage() {
      return i18n["messages"][this.current_locale]["checklistRequiredToComplete"];
    },

    checklistParentData() {
      return {
        row: this.row,
        grid: this.grid,
      };
    },
  },

  created() {
    this.fieldsLoaded();
    this.initializeChecklistFields();
  },

  methods: {
    getFieldComponent(key) {
      return fields[key];
    },

    getFieldData(field) {
      return this.fields.filter(f => f === field);
    },

    getChecklistData(field) {
      return {
        title: field.value,
        status: field.checklist_status,
        status_title: field.checklist_status_title,
        checklist_started: field.checklist_started,
        can_edit: field.checklist_status === "in_progress",
      };
    },

    checklistIsValid(field) {
      return !field.require || completedChecklistStatuses.includes(field.checklist_status);
    },

    showChecklistError(field) {
      return Boolean(this.currentForm?.invalid_fields?.[field.name]);
    },

    initializeChecklistFields() {
      this.fields
        .filter(field => field.type === "checklist")
        .forEach(field => {
          this.$store.commit("createFormField", { grid_name: this.grid, field: field.name });
          this.updateChecklistFormField(field);
        });
    },

    updateChecklistFormField(field) {
      const result = {
        field: field.checklist_status,
        invalid: !this.checklistIsValid(field),
      };

      this.$store.commit("updateFormField", { grid_name: this.grid, field: field.name, value: result });

      if (!result.invalid) {
        this.$store.commit("resetFormFieldValue", {
          grid_name: this.grid,
          field: "invalid_fields",
          value: field.name,
        });
      }
    },

    getChecklistUpdatedStatus(data) {
      if (data?.data?.status) {
        return data.data.status;
      }

      if (data?.complete) {
        return "completed";
      }

      return data?.data?.status;
    },

    onChecklistUpdated(field, data) {
      const status = this.getChecklistUpdatedStatus(data);

      if (status) {
        field.checklist_status = status;
        field.checklist_status_title = data?.data?.status_title ?? field.checklist_status_title;
      }

      this.updateChecklistFormField(field);
      this.$emit("checklist-updated", data);
    },

    dataHasLoaded() {
      return !this.loading;
    },

    fieldIsForbidden(name) {
      // нам нужно установить в данные по полю с бэкенда forbidden,
      // чтобы при watch мы могли отсеять поле и уменьшить количество родителей.
      // мы не можем сделать это напрямую в select_field, потому что у нас несколько экземпляров селектов,
      // которые объединены общим пропом allFields, содержащим первичные данные с бэка
      const index = this.fields.findIndex(el => el.name === name);
      if (index !== -1) {
        this.fields[index].value = null;
        this.fields[index].forbidden = true;
      }
    },

    fieldsLoaded(field = undefined) {
      if (this.loading_fields.length === 0) {
        this.loading_fields = this.fields
          .filter(f => this.$store.state.fields_with_options.includes(f.type))
          .map(f => [f.type, f.name]);
      }

      if (field) {
        this.loading_fields = this.loading_fields.filter(f => f.sort().toString() !== field.sort().toString());
      }

      if (this.loading_fields.length === 0) {
        this.loading = false;
        this.emitter.emit("allFieldsLoaded");
      }

      this.$emit("loading-form", this.loading);
    },
  },
};
</script>

<style scoped lang="scss">
.transition-checklist-field {
  &__error {
    display: block;
    margin: 8px 0 0;
  }

  &__status {
    margin-bottom: 8px;
    color: var(--field-input-color);
  }
}
</style>
